export const EMPTY_POLL = {
  id: null,
  data: {
    pageType: null,
    name: null,
    description: null,
    photos: {
      visualIdentity: null,
      slider: null,
    },
  },
  project: {
    sourceOfProjects: null,
    selectedContestId: null,
    listOfSelectedProjects: []
  },
  configuration: {
    publicationDate: null,
    deadlineForVotingOnProjects: {
      from: null,
      to: null,
    },
    customLink: null,
    projectDataForDisplay: {
      entrepreneurName: null,
      entrepreneurAbout: null,
      entrepreneurFoundedOn: null,
      entrepreneurType: null,
      nameOfProject: null,
      description: null,
      questions: [],
      projectStatus: null,
      idwall_status: null,
      proposedValue: null,
      approvedValue: null,
      fundingSource: null,
      actingLocations: null,
      targetsAudience: null,
      movies: null,
      sites: null,
      complementaryFiles: null,
      ods: null,
      areasOfInterest: null,
      subareasOfInterest: null,
      socialNetwork: null,
      evaluation: null
    },
    scoreAsPrivate: false,
    voteLimitPerEmail: null,
    votingRestrictionByEmail: null,
  },
  isDraft: null,
}


// WEBPACK FOOTER //
// ./src/sample/Poll.js